import type { SxProps, Theme } from '@mui/material/styles';
import { cardSx } from '../../shared/utils/styles.ts';

export const metricGroupSx: SxProps<Theme> = { ...cardSx, p: 1.5, minWidth: 0 };
